import { render, staticRenderFns } from "./PagePayeeInfo.vue?vue&type=template&id=ff12381e&"
import script from "./PagePayeeInfo.vue?vue&type=script&lang=ts&"
export * from "./PagePayeeInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports